<template>
  <div class="card" @click="moveToDetails">
    <div class="name">{{ customer.firstName }} {{ customer.lastName }}</div>
    <div class="phone">{{ customer.phone }}</div>
    <div class="address">{{ customer.address }}</div>
    <div class="footer">
      <img
        v-if="customer.isPriority"
        src="../../icons/dod/important.svg"
        alt=""
      />
      <div>
        <img src="../../icons/dod/read_message.svg" alt="" />
        <span class="ml-2">{{ customer.numberOfMessages }}</span>
      </div>

      <div>
        <img src="../../icons/dod/notes.svg" alt="" />
        <span class="ml-2">{{ customer.numberOfTasks }}</span>
      </div>

      <div v-if="customer.region" class="region">{{ customer.region }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomerCard",
  components: {},
  props: {
    customer: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    moveToDetails() {
      this.$router.push({
        name: "DodCustomerDetails",
        params: { id: this.customer.id },
      });
    },
  },
};
</script>
<style scoped>
.card {
  width: calc(100% * (1 / 4) - 10px - 1px);
  display: flex;
  padding: 16px;
  border-radius: 8px;
  border: 0.5px solid var(--granatowy-25, rgba(9, 7, 65, 0.25));
  background: var(--white-white, #fff);
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.25);
  margin-bottom: 1rem;
  cursor: pointer;
  height: 136px;
  justify-content: center;
}
.footer {
  display: flex;
  gap: 1rem;
  align-items: center;
}
/* Rejon dosunięty do prawej krawędzi wizytówki, wyróżniony jak na makiecie. */
.region {
  margin-left: auto;
  color: var(--gray-800, #1f2633);
  font-family: Poppins;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.name {
  color: var(--gray-800, #1f2633);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 0.5rem;
}
.phone,
.address {
  color: var(--gray-800, #1f2633);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
}
.card:hover {
  background: #f1f1f1;
}
</style>
